const allowedLocales = ['de', 'es', 'lv', 'fr', 'ru', 'it'];

export const getLocalizedLinks = (locale: string) => {
  const normalized = allowedLocales.includes(locale.toLowerCase()) ? locale.toLowerCase() : 'en';
  return {
    privacyLink: `https://weststeincard.com/${normalized}/private/privacy-policy`,
    termsLink: `https://weststeincard.com/${normalized}/private/terms-and-conditions`,
  };
};
